<div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <ul class="mt-2 w-100 list-group">
        <li class="list-group-item subheader d-block py-1">
            <div class="row w-100 d-flex align-items-center">
                <div class="col"><span translate="Permissions.Components.OptionHeader"></span></div>
                <ng-container *ngIf="showConfig">
                    <div class="col-2"><span translate="Permissions.Components.VisibleHeader"></span></div>
                    <div class="col-2"><span translate="Permissions.Components.LockHeader"></span></div>
                    <!-- the disabled header is hidden when the checkboxes are also not shown -->
                    <ng-container *ngIf="showDisabledHeader">
                        <div class="col-2"><span translate="Permissions.Components.DisabledHeader"></span></div>
                    </ng-container>
                    <ng-container *ngIf="showForce">
                        <div class="col-1"></div>
                    </ng-container>
                </ng-container>
            </div>
        </li>

        <ng-container *ngFor="let permission of permissions">
            <app-hide-by-permission-wrapper [forPermission]="permission.name" [showWhenHidden]="showWhenHidden">
                <app-configure-permission [forPermission]="permission.name" [level]="level">
                    <div class="row w-100 d-flex align-items-center">
                        <div class="col-12 text-truncate float-none form-check form-switch">
                            <app-permissioned-switch [forPermission]="permission.name" [forItself]=true
                                [givenId]="permission.name" (valueSwitched)="update(permission.name,$event)">
                            </app-permissioned-switch>
                            <label [for]="permission.name" class="form-check-label col-10"
                                translate="Permissions.Names.{{permission.name}}"></label>
                        </div>
                    </div>
                </app-configure-permission>
            </app-hide-by-permission-wrapper>
        </ng-container>
    </ul>
</div>